import classNames from 'classnames';
import React from 'react';

import { avenirFont } from '@/utils/font';

import styles from './styles.module.scss';
import { Props } from './types';

const Input = ({
  type = 'text',
  value,
  onChange,
  onKeyDown,
  placeholder,
  id,
  name,
  children,
  isError = false,
  isDarkBgc = false,
  isBorderNone = false,
  errorMsg,
  className,
  ...otherProps
}: Props) => {
  const input = classNames(
    styles.input,
    className && className,
    avenirFont.className,
    isDarkBgc && styles.darkBgc,
    isBorderNone && styles.borderNone,
  );
  return (
    <>
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={input}
        id={id}
        onKeyDown={onKeyDown}
        {...otherProps}
      />
      {children}
      {isError && (
        <p className={styles.error} data-error>
          {errorMsg}
        </p>
      )}
    </>
  );
};

export default Input;
